module.exports = __webpack_public_path__ + "img/otk_logo.ea98435a.png";